import React from 'react';

import { guideMessages } from '../../../translates/guideMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { useScrollGuidedTour } from '../../hooks/useScrollGuidedTour';
import { BackdropOverlay, ScrollGuidedTour } from '@ael/shared-components-library';
import Floater from 'react-floater';

type StudentScrollGuidedDialogProps = {
  children: React.ReactNode;
  targetRef: React.RefObject<HTMLElement>;
};

export const StudentScrollGuidedDialog = ({ children, targetRef }: StudentScrollGuidedDialogProps) => {
  const { formatMessage } = useIntlReexport();
  const { isShowing, dismiss } = useScrollGuidedTour();

  return (
    <Floater
      component={
        <ScrollGuidedTour
          variant="student"
          title={formatMessage(guideMessages.scrollIndicatorTitle)}
          description={formatMessage(guideMessages.scrollIndicatorDescription)}
          buttonLabel={formatMessage(guideMessages.scrollIndicatorButtonLabel)}
          onClose={dismiss}
        />
      }
      open={isShowing}
      placement="top"
      styles={{ wrapper: { cursor: 'default' } }}
      hideArrow
    >
      {children}
      {isShowing && <BackdropOverlay refForSpotlight={targetRef} />}
    </Floater>
  );
};
